const patientDetailsDrawerBody = {
  sectionTitles: {
    demographics: "Demographics",
    biometrics: "Biometrics",
    goals: "Goals",
    conditions: "Conditions",
    currentlyTaking: "Currently taking",
  },
  emptyDemographicsFallback: "No demographics provided",
  emptyCurrentlyTakingDetailsFallback: "No brand or dosage provided",
} as const;

export { patientDetailsDrawerBody };
